import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Price } from '../../interfaces/IPrice';
import { setPricesFromPlans } from '../utils/planPrices';
import { getPrices } from '../services';

type PricesContextType = {
  prices: Price[];
  loading: boolean;
  total: string;
  setTotal: Dispatch<SetStateAction<string>>;
};

export const PricesContext = React.createContext<PricesContextType | undefined>(undefined);

// Make sure to use PricesContext one level up from where you want to consume values
const PricesProvider: React.FunctionComponent = ({ children }) => {
  const [prices, setPrices]: [Price[], Dispatch<SetStateAction<Price[]>>] = useState([] as Price[]);
  const [loading, setLoading]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(
    true as boolean
  );
  const [total, setTotal]: [string, Dispatch<SetStateAction<string>>] = useState('0.00' as string);

  useEffect(() => {
    getPrices().then((plans) => {
      setPrices(setPricesFromPlans(plans));
      setLoading(false);
    });
  }, []);

  return (
    <PricesContext.Provider
      value={{
        prices,
        loading,
        total,
        setTotal,
      }}
    >
      {children}
    </PricesContext.Provider>
  );
};

// This hook is the equivalent of a context consumer
// TO USE: const PricesContext = usePricesContext();
// MAKE SURE that <PricesProvider> is a level up
export function usePricesContext() {
  const context = React.useContext(PricesContext);
  if (!context) {
    throw new Error('You must use the Prices Provider in order to consume this context.');
  }
  return context;
}

export default PricesProvider;
